import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchPromotionListingAPI(filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/promotion/all?${getQueryString(filters)}`);
}

export async function getSinglePromotionAPI(promotionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/promotion/${promotionId}`);
}

export async function createPromotionAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/promotion`, data);
}

export async function updatePromotionAPI(data, promotionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/promotion/${promotionId}`, data);
}

export async function deletePromotionAPI(promotionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/promotion/${promotionId}`);
}
export async function getPromotionCartRulesByTypeAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/cart/rules`);
}


export async function getPromotionProductRulesByTypeAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/product/rules`);
}

export async function downloadPromotionAsPdfAPI(promotionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/download/csv/promo/${promotionId}`);
}